import type { StoreApi } from 'zustand';
import { createStore } from 'zustand';

export type ManualEditState = {
    readonly hasManualEdits: boolean;
};

export type ManualEditActions = {
    readonly resetManualEdits: () => void;
    readonly setHasManualEdits: (value: boolean) => void;
};

export type ManualEditStore = ManualEditActions & ManualEditState;

export const createManualEditStore = (): StoreApi<ManualEditStore> => {
    return createStore<ManualEditStore>((set) => ({
        hasManualEdits: false,

        resetManualEdits: () => set({ hasManualEdits: false }),
        setHasManualEdits: (value) => set({ hasManualEdits: value }),
    }));
};
